import { Pipe, PipeTransform } from '@angular/core';
import { AnySrvRecord } from 'dns';
import { Product } from 'src/app/model/price/product';

@Pipe({
  name: 'productGram'
})
export class ProductGramPipe implements PipeTransform {

  transform(value: any, ...args: unknown[]): string {

    if (value?.metalList?.length > 1) {
      return "MIX_PRODUCT"
    }else if(value?.metalList?.length == 1) {
          return `${value?.metalList[0]?.weight} g`;
    }else{
      return `${value?.weight} g`
    }

  }

}
